// import React, { useEffect, useState, useRef } from "react";
// import "./Courseleveldetails.css";
// import { Link, useParams, useLocation } from "react-router-dom";
// import axios from "axios";
// import RegisterButton from "../RegisterProtect/RegisterButton";
// import EnrollButton from "../EnrollLink/EnrollLink";

// export default function CourseLevelPage() {
//   const location = useLocation();
//   const { levelData, memberAmount, nonMemberAmount } = location.state || {};
//   const [profileData, setProfileData] = useState(null);

//   const sectionRef = useRef(null);
//   const { courseId, levelId } = useParams();
//   const [level, setLevel] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const handleScroll = () => {
//     sectionRef.current?.scrollIntoView({ behavior: "smooth" });
//   };

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (user?.email) {
//       fetch(
//         `https://agepcoatings.com/getuserbyemail/${encodeURIComponent(
//           user.email
//         )}`
//       )
//         .then((res) => res.json())
//         .then((data) => {
//           if (data.success) setProfileData(data.data);
//         });
//     }
//   }, []);

//   const finalAmount = profileData?.isMember ? memberAmount : nonMemberAmount;

//   useEffect(() => {
//     const fetchLevel = async () => {
//       try {
//         const res = await axios.get(
//           `https://agepcoatings.com/getcourse/${courseId}`
//         );
//         const course = res.data;

//         // find specific level
//         const selectedLevel = course.levelsData.find(
//           (lvl) => String(lvl.levelId) === String(levelId)
//         );
//         setLevel(selectedLevel);
//       } catch (err) {
//         console.error("Error fetching level details:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchLevel();
//   }, [courseId, levelId]);

//   if (loading) return <p>Loading...</p>;
//   if (!level) return <p>Level not found</p>;

//   if (!levelData) {
//     return <p>Level data not available</p>; // fallback for direct URL access
//   }
//   if (!levelData) return <p>Level data not available</p>;

//   return (
//     <section className="details-courses-level mb-5">
//       <div className="container course-leveldetais">
//         <Link to={`/courses/${courseId}`} className="btn custom-back-btn mb-4">
//           ← Back to Levels
//         </Link>

//         <h2
//           className="text-2xl md:text-3xl fw-bold mb-4"
//           style={{ color: "#101727" }}
//         >
//           Courses
//         </h2>

//         {/* === Top Row === */}
//         <div className="row top-cards-row align-items-start">
//           {/* Left: Banner */}
//           <div className="col-lg-8 mb-3 mb-lg-0">
//             <div className="position-relative rounded-4 overflow-hidden banner-card">
//               <div
//                 className="details-level-bg"
//                 style={{
//                   backgroundImage: `url(${level?.levelDetails.detailsbanner_image})`,
//                 }}
//               />
//               <div className="banner-content p-4 text-white h-100 d-flex flex-column justify-content-between">
//                 <div>
//                   <span className="badge bg-white text-dark mb-3">
//                     {level?.levelDetails.detailsbanner_badge}
//                   </span>
//                   <h3 className="fw-bold mb-2">
//                     {level?.levelDetails.detailsbanner_title}
//                   </h3>
//                   <p className="mb-4">
//                     {level?.levelDetails.detailsbanner_description}
//                   </p>
//                   <div className="d-flex flex-wrap gap-3 display-level-status">
//                     <div className="d-flex align-items-center gap-2 px-3 py-2 rounded bg-opacity-25">
//                       <i className="bi bi-star-fill text-warning"></i>
//                       <strong>
//                         {level?.levelDetails.detailsbanner_ratings}
//                       </strong>
//                     </div>
//                     <div className="d-flex align-items-center gap-2 px-3 py-2 rounded bg-opacity-25">
//                       <i className="bi bi-people-fill"></i>Enroll
//                       {level?.levelDetails.detailsbanner_enrolled}
//                     </div>
//                     <div className="d-flex align-items-center gap-2 px-3 py-2 rounded aviliability">
//                       <i className="bi bi-calendar-event"></i>
//                       <strong onClick={handleScroll}>
//                         {level?.levelDetails.detailsbanner_availability_link}
//                       </strong>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="mt-4 d-flex">
//                   <div className="w-25 me-2">
//                     <EnrollButton
//                       className="w-100"
//                       courseId={courseId}
//                       levelId={levelId}
//                       courseTitle={level?.levelDetails?.detailsbanner_title}
//                       levelbadge={level?.levelDetails?.detailsbanner_badge}
//                       amount={finalAmount}
//                       disabled={!profileData} // disable until profile is loaded
//                     />
//                   </div>
//                   {/* <div className="w-25 mt-2">
//                     <button className="btn btn-light text-dark rounded-5 w-100">
//                       {level?.levelDetails.detailsbanner_cta_badgenote}
//                     </button>
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right: Info Card */}
//           <div className="col-lg-4">
//             <div className="bg-white rounded-4 p-4 shadow border h-100 certified-card">
//               <div className="mb-3 d-flex align-items-center gap-3">
//                 <div className="bg-light rounded-circle p-2">
//                   <i className="bi bi-clock"></i>
//                 </div>
//                 <span>{level?.levelDetails.detailssidesection1_duration}</span>
//               </div>
//               <div className="mb-3 d-flex align-items-center gap-3">
//                 <div className="bg-light rounded-circle p-2">
//                   <i className="bi bi-globe"></i>
//                 </div>
//                 <span>{level?.levelDetails.detailssidesection1_language}</span>
//               </div>
//               {level?.levelDetails.detailssidesection1_CEUs && (
//                 <div className="mb-3 d-flex align-items-center gap-3">
//                   <div className="bg-light rounded-circle p-2">
//                     <i className="bi bi-person"></i>
//                   </div>
//                   <span>{level?.levelDetails.detailssidesection1_CEUs}</span>
//                 </div>
//               )}
//               <div className="mb-3 d-flex align-items-center gap-3">
//                 <div className="bg-light rounded-circle p-2">
//                   <i className="bi bi-award"></i>
//                 </div>
//                 <span>
//                   {level?.levelDetails.detailssidesection1_certification}
//                 </span>
//               </div>
//               <p className="small text-muted">
//                 {level?.levelDetails.detailssidesection1_note}
//               </p>

//               <RegisterButton className="custom-view-btn w-100 border-0" />
//             </div>
//           </div>
//         </div>

//         <div></div>
//         {/* === Content Section === */}
//         <div className="row mt-4 g-4">
//           {/* Left Column */}
//           <div className="col-lg-8">
//             {/* About */}
//             <h3 className="details-title-course mb-3">
//               {level?.levelDetails.detailssection1_heading}
//             </h3>
//             <div className="p-4 about-details-level rounded">
//               {level?.levelDetails.detailssection1_description && (
//                 <p>{level?.levelDetails.detailssection1_description}</p>
//               )}

//               {level?.levelDetails.detailssection1_subheading && (
//                 <p className="fw-bold">
//                   {level?.levelDetails.detailssection1_subheading}
//                 </p>
//               )}
//               {level?.levelDetails.detailssection1_subheading_description && (
//                 <p className="text-small">
//                   {level?.levelDetails.detailssection1_subheading_description}
//                 </p>
//               )}
//               <ul className="list-unstyled">
//                 {level?.levelDetails.detailssection1_pointer1 && (
//                   <li>
//                     <i className="bi bi-check-circle text-dark me-2"></i>
//                     {level?.levelDetails.detailssection1_pointer1}
//                   </li>
//                 )}
//                 {level?.levelDetails.detailssection1_pointer2 && (
//                   <li>
//                     <i className="bi bi-check-circle text-dark me-2"></i>
//                     {level?.levelDetails.detailssection1_pointer2}
//                   </li>
//                 )}
//                 {level?.levelDetails.detailssection1_pointer3 && (
//                   <li>
//                     <i className="bi bi-check-circle text-dark me-2"></i>
//                     {level?.levelDetails.detailssection1_pointer3}
//                   </li>
//                 )}
//                 {level?.levelDetails.detailssection1_pointer4 && (
//                   <li>
//                     <i className="bi bi-check-circle text-dark me-2"></i>
//                     {level?.levelDetails.detailssection1_pointer4}
//                   </li>
//                 )}
//                 {level?.levelDetails.detailssection1_pointer5 && (
//                   <li>
//                     <i className="bi bi-check-circle text-dark me-2"></i>
//                     {level?.levelDetails.detailssection1_pointer5}
//                   </li>
//                 )}
//                 {level?.levelDetails.detailssection1_pointer6 && (
//                   <li>
//                     <i className="bi bi-check-circle text-dark me-2"></i>
//                     {level?.levelDetails.detailssection1_pointer6}
//                   </li>
//                 )}
//                 <span>
//                   <Link
//                     to="/"
//                     style={{ textDecoration: "none", color: "#000" }}
//                   >
//                     Ready to become a certified inspector? Register Now
//                   </Link>
//                 </span>
//               </ul>
//             </div>

//             {level?.levelDetails.detailssection1_pointer4 && (
//               <li>
//                 <i className="bi bi-check-circle text-dark me-2"></i>
//                 {level?.levelDetails.detailssection1_pointer4}
//               </li>
//             )}
//             {/* Description */}
//             {level?.levelDetails.detailssection2_heading && (
//               <h3 className="description-clss mt-5 mb-3">
//                 {level?.levelDetails.detailssection2_heading}
//               </h3>
//             )}
//             {level?.levelDetails.detailssection2_description && (
//               <p className="about-description p-3">
//                 {level?.levelDetails.detailssection2_description}
//               </p>
//             )}

//             {/* Learning Objectives */}
//             {level?.levelDetails.detailssection3_heading && (
//               <h3 className="lern-course mt-5 mb-3">
//                 {level?.levelDetails.detailssection3_heading}
//               </h3>
//             )}

//             <ul className="list-unstyled about-description p-3 mb-3">
//               {level?.levelDetails.detailssection3_pointer1 && (
//                 <li>
//                   <i className="bi bi-check-circle-fill text-dark me-2"></i>
//                   {level?.levelDetails.detailssection3_pointer1}
//                 </li>
//               )}
//               {level?.levelDetails.detailssection3_pointer2 && (
//                 <li>
//                   <i className="bi bi-check-circle-fill text-dark me-2"></i>
//                   {level?.levelDetails.detailssection3_pointer2}
//                 </li>
//               )}
//               {level?.levelDetails.detailssection3_pointer3 && (
//                 <li>
//                   <i className="bi bi-check-circle-fill text-dark me-2"></i>
//                   {level?.levelDetails.detailssection3_pointer3}
//                 </li>
//               )}
//               {level?.levelDetails.detailssection3_pointer4 && (
//                 <li>
//                   <i className="bi bi-check-circle-fill text-dark me-2"></i>
//                   {level?.levelDetails.detailssection3_pointer4}
//                 </li>
//               )}
//               {level?.levelDetails.detailssection3_pointer5 && (
//                 <li>
//                   <i className="bi bi-check-circle-fill text-dark me-2"></i>
//                   {level?.levelDetails.detailssection3_pointer5}
//                 </li>
//               )}
//               {level?.levelDetails.detailssection3_pointer6 && (
//                 <li>
//                   <i className="bi bi-check-circle-fill text-dark me-2"></i>
//                   {level?.levelDetails.detailssection3_pointer6}
//                 </li>
//               )}
//               {level?.levelDetails.detailssection3_pointer7 && (
//                 <li>
//                   <i className="bi bi-check-circle-fill text-dark me-2"></i>
//                   {level?.levelDetails.detailssection3_pointer7}
//                 </li>
//               )}
//               {level?.levelDetails.detailssection3_pointer8 && (
//                 <li>
//                   <i className="bi bi-check-circle-fill text-dark me-2"></i>
//                   {level?.levelDetails.detailssection3_pointer8}
//                 </li>
//               )}
//               {level?.levelDetails.detailssection3_pointer9 && (
//                 <li>
//                   <i className="bi bi-check-circle-fill text-dark me-2"></i>
//                   {level?.levelDetails.detailssection3_pointer9}
//                 </li>
//               )}
//               {/* <button className="custom-kickstart border-0 mt-3">
//                 Kickstart your inspection career today!
//               </button> */}
//             </ul>

//             {/* Course Completion */}
//             <div className="col-12 course-req-com mb-0">
//               {level?.levelDetails.detailssection4_heading && (
//                 <h3>{level?.levelDetails.detailssection4_heading}</h3>
//               )}
//               <ul>
//                 {level?.levelDetails.detailssection4_pointer1 && (
//                   <li>
//                     <p>{level?.levelDetails.detailssection4_pointer1}</p>
//                   </li>
//                 )}
//                 {level?.levelDetails.detailssetion4_pointer2 && (
//                   <li>
//                     <p>{level?.levelDetails.detailssetion4_pointer2}</p>
//                   </li>
//                 )}
//                 {level?.levelDetails.detailssection4_pointer3 && (
//                   <li>
//                     <p>{level?.levelDetails.detailssection4_pointer3}</p>
//                   </li>
//                 )}
//                 {level?.levelDetails.detailssection4_pointer4 && (
//                   <li>
//                     <p>{level?.levelDetails.detailssection4_pointer4}</p>
//                   </li>
//                 )}

//                 {level?.levelDetails.detailssection4_heading && (
//                   <p>{level?.levelDetails.detailssection4_description}</p>
//                 )}
//               </ul>
//               <RegisterButton className="custom-course-req-com-btn border-0 mb-5" />
//             </div>
//           </div>

//           {/* Right Column */}
//           <div className="col-lg-4 d-flex flex-column gap-3">
//             {/* Steps */}
//             <div className="certified-card rounded-4 p-4 shadow border">
//               <h4 className="fw-bold mb-4">
//                 {level?.levelDetails.detailsidesection2_title}
//               </h4>
//               <ul className="steps-list m-0 p-0 list-unstyled">
//                 <li className="d-flex position-relative mb-4">
//                   <div className="icon-circle bg-dark text-white d-flex align-items-center justify-content-center">
//                     <i className="bi bi-check"></i>
//                   </div>
//                   <div className="ms-3">
//                     {level?.levelDetails.detailsidesection2_pointer1}
//                   </div>
//                   <div className="step-line"></div>
//                 </li>
//                 <li className="d-flex position-relative mb-4">
//                   <div className="icon-circle bg-dark text-white d-flex align-items-center justify-content-center">
//                     <i className="bi bi-check"></i>
//                   </div>
//                   <div className="ms-3">
//                     {level?.levelDetails.detailsidesection2_pointer2}
//                   </div>
//                   <div className="step-line"></div>
//                 </li>
//                 <li className="d-flex position-relative mb-4">
//                   <div className="icon-circle bg-dark text-white d-flex align-items-center justify-content-center">
//                     <i className="bi bi-check"></i>
//                   </div>
//                   <div className="ms-3">
//                     {level?.levelDetails.detailssidesection2_pointer3}
//                   </div>
//                   <div className="step-line"></div>
//                 </li>
//               </ul>
//             </div>

//             {/* Bottom Card */}
//             <div className="about-bttom-card text-dark p-4 rounded shadow border">
//               {level?.levelDetails?.detailssidesection3_image && (
//                 <img
//                   src={level.levelDetails.detailssidesection3_image}
//                   alt="Career"
//                   className="img-fluid rounded mb-3"
//                 />
//               )}
//               <h4 className="fw-bold">
//                 {level?.levelDetails.detailsidesection3_title}
//               </h4>
//               <p>{level?.levelDetails.detailssidesecion3_description}</p>
//               <RegisterButton className="details-course-reg w-100 border-0" />
//             </div>
//           </div>
//           <div className="main-schedule" ref={sectionRef}>
//             <h3 className="course-prices">Course Price </h3>
//             <p
//               className="shadul-link text-dark p-4 rounded"
//               style={{ background: "#F6F5F5" }}
//             >
//               <p>Member Price: ${memberAmount} USD</p>
//               <p>Non-Member Price: ${nonMemberAmount} USD</p>
//             </p>
//             <h2
//               style={{
//                 color: "#101727",
//                 fontFamily: "manrope",
//                 fontSize: "24px",
//               }}
//               className="fw-sm"
//             >
//               Course Schedule
//             </h2>
//             <div
//               className="shadul-link text-dark p-4 rounded"
//               style={{ background: "#F6F5F5" }}
//             >
//               <ul>
//                 <li>Day 1: 8:00 AM to 6:00 PM</li>
//                 <li>Day 2: 8:00 AM to 6:00 PM</li>
//                 <li>Day 3: 8:00 AM to 6:00 PM</li>
//                 <li>Day 4: 8:00 AM to 6:00 PM</li>
//                 <li>Day 5: 8:00 AM to 6:00 PM</li>
//                 <li>Day 6: 8:00 AM to 6:00 PM</li>
//                 <li>Day 7: 8:00 AM to 6:00 PM</li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

import React, { useEffect, useState, useRef } from "react";
import "./Courseleveldetails.css";
import { Link, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import RegisterButton from "../RegisterProtect/RegisterButton";
import EnrollButton from "../EnrollLink/EnrollLink";

export default function CourseLevelPage() {
  const location = useLocation();
  const { levelData, memberAmount, nonMemberAmount } = location.state || {};
  const [profileData, setProfileData] = useState(null);

  const sectionRef = useRef(null);
  const { courseId, levelId } = useParams();
  const [level, setLevel] = useState(null);
  const [loading, setLoading] = useState(true);

  // const handleScroll = () => {
  //   sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  // };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.email) {
      fetch(
        `https://agepcoatings.com/getuserbyemail/${encodeURIComponent(
          user.email
        )}`
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.success) setProfileData(data.data);
        });
    }
  }, []);

  const finalAmount = profileData?.isMember ? memberAmount : nonMemberAmount;

  useEffect(() => {
    const fetchLevel = async () => {
      try {
        const res = await axios.get(
          `https://agepcoatings.com/getcourse/${courseId}`
        );
        const course = res.data;

        // find specific level
        const selectedLevel = course.levelsData.find(
          (lvl) => String(lvl.levelId) === String(levelId)
        );
        setLevel(selectedLevel);
      } catch (err) {
        console.error("Error fetching level details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchLevel();
  }, [courseId, levelId]);

  if (loading) return <p>Loading...</p>;
  if (!level) return <p>Level not found</p>;

  if (!levelData) {
    return <p>Level data not available</p>; // fallback for direct URL access
  }
  if (!levelData) return <p>Level data not available</p>;

  return (
    <section className="details-courses-level mb-md-5">
      <div className="container course-leveldetais">
        <Link to={`/courses/${courseId}`} className="btn custom-back-btn mb-4">
          ← Back to Levels
        </Link>

        <h2 className="text-2xl md:text-3xl font-semibold mb-4">Courses</h2>

        {/* === Top Row === */}
        <div className="row top-cards-row align-items-start">
          {/* Left: Banner */}
          <div className="col-lg-8 mb-3 mb-lg-0">
            <div className="position-relative rounded-4 overflow-hidden banner-card">
              <div
                className="details-level-bg"
                style={{
                  backgroundImage: `url(${level?.levelDetails.detailsbanner_image})`,
                }}
              />
              <div className="banner-content p-4 text-white h-100 d-flex flex-column justify-content-between">
                <div>
                  <span className="badge bg-white text-dark mb-3">
                    {level?.levelDetails.detailsbanner_badge}
                  </span>
                  <h3 className="fw-bold mb-2">
                    {level?.levelDetails.detailsbanner_title}
                  </h3>
                  <p className="mb-4">
                    {level?.levelDetails.detailsbanner_description}
                  </p>
                  <div className="d-flex flex-wrap gap-2 display-level-status">
                    <div className="d-flex align-items-center gap-1 px-3 py-2 rounded bg-opacity-25">
                      <i className="bi bi-star-fill text-warning"></i>
                      <strong>
                        {level?.levelDetails.detailsbanner_ratings}
                      </strong>
                    </div>
                    <div className="me-2">
                      <EnrollButton
                        className="w-100"
                        courseId={courseId}
                        levelId={levelId}
                        courseTitle={level?.levelDetails?.detailsbanner_title}
                        levelbadge={level?.levelDetails?.detailsbanner_badge}
                        amount={finalAmount}
                        disabled={!profileData} // disable until profile is loaded
                      />
                    </div>
                    {/* <div className="d-flex align-items-center gap-1 px-3 py-2 rounded aviliability">
                      <i className="bi bi-calendar-event"></i>
                      <strong onClick={handleScroll}>
                        {level?.levelDetails.detailsbanner_availability_link}
                      </strong>
                    </div> */}
                  </div>
                </div>
                <div className="mt-md-4 d-flex">
                  {/* <div className="me-2">
                    <EnrollButton
                      className="w-100"
                      courseId={courseId}
                      levelId={levelId}
                      courseTitle={level?.levelDetails?.detailsbanner_title}
                      levelbadge={level?.levelDetails?.detailsbanner_badge}
                      amount={finalAmount}
                      disabled={!profileData} // disable until profile is loaded
                    />
                  </div> */}
                  {/* <div className="w-25 mt-2">
                    <button className="btn btn-light text-dark rounded-5 w-100">
                      {level?.levelDetails.detailsbanner_cta_badgenote}
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          {/* Right: Info Card */}
          <div className="col-lg-4">
            <div className="rounded-4 p-4 shadow border h-100 certified-card">
              <div className="mb-3 d-flex align-items-center gap-3">
                <div className="bg-light rounded-circle p-2">
                  <i className="bi bi-clock"></i>
                </div>
                <span>{level?.levelDetails.detailssidesection1_duration}</span>
              </div>
              <div className="mb-3 d-flex align-items-center gap-3">
                <div className="bg-light rounded-circle p-2">
                  <i className="bi bi-globe"></i>
                </div>
                <span>{level?.levelDetails.detailssidesection1_language}</span>
              </div>
              {level?.levelDetails.detailssidesection1_CEUs && (
                <div className="mb-3 d-flex align-items-center gap-3">
                  <div className="bg-light rounded-circle p-2">
                    <i className="bi bi-person"></i>
                  </div>
                  <span>{level?.levelDetails.detailssidesection1_CEUs}</span>
                </div>
              )}
              <div className="mb-3 d-flex align-items-center gap-3">
                <div className="bg-light rounded-circle p-2">
                  <i className="bi bi-award"></i>
                </div>
                <span>
                  {level?.levelDetails.detailssidesection1_certification}
                </span>
              </div>
              <p className="small text-muted">
                {level?.levelDetails.detailssidesection1_note}
              </p>

              <RegisterButton className="custom-view-btn w-100 border-0" />
            </div>
          </div>
        </div>

        {/* === Content Section === */}
        <div className="row mt-4 g-4">
          {/* Left Column */}
          <div className="col-lg-8">
            {/* About */}
            <h3 className="details-title-course mb-3">
              {level?.levelDetails.detailssection1_heading}
            </h3>
            <div className="p-4 about-details-level rounded">
              {level?.levelDetails.detailssection1_description && (
                <p>{level?.levelDetails.detailssection1_description}</p>
              )}

              {level?.levelDetails.detailssection1_subheading && (
                <p className="fw-bold" style={{ fontSize: "16px" }}>
                  {level?.levelDetails.detailssection1_subheading}
                </p>
              )}
              {level?.levelDetails.detailssection1_subheading_description && (
                <p className="text-small">
                  {level?.levelDetails.detailssection1_subheading_description}
                </p>
              )}
              <ul className="list-unstyled list-description">
                {level?.levelDetails.detailssection1_pointer1 && (
                  <li>
                    <i className="bi bi-check-circle text-dark me-2"></i>
                    {level?.levelDetails.detailssection1_pointer1}
                  </li>
                )}
                {level?.levelDetails.detailssection1_pointer2 && (
                  <li>
                    <i className="bi bi-check-circle text-dark me-2"></i>
                    {level?.levelDetails.detailssection1_pointer2}
                  </li>
                )}
                {level?.levelDetails.detailssection1_pointer3 && (
                  <li>
                    <i className="bi bi-check-circle text-dark me-2"></i>
                    {level?.levelDetails.detailssection1_pointer3}
                  </li>
                )}
                {level?.levelDetails.detailssection1_pointer4 && (
                  <li>
                    <i className="bi bi-check-circle text-dark me-2"></i>
                    {level?.levelDetails.detailssection1_pointer4}
                  </li>
                )}
                {level?.levelDetails.detailssection1_pointer5 && (
                  <li>
                    <i className="bi bi-check-circle text-dark me-2"></i>
                    {level?.levelDetails.detailssection1_pointer5}
                  </li>
                )}
                {level?.levelDetails.detailssection1_pointer6 && (
                  <li>
                    <i className="bi bi-check-circle text-dark me-2"></i>
                    {level?.levelDetails.detailssection1_pointer6}
                  </li>
                )}
                <span>
                  <Link
                    to="/"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    Ready to become a certified inspector? Register Now
                  </Link>
                </span>
              </ul>
            </div>

            {/* {level?.levelDetails.detailssection1_pointer4 && (
              <li>
                <i className="bi bi-check-circle text-dark me-2"></i>
                {level?.levelDetails.detailssection1_pointer4}
              </li>
            )} */}
            {/* Description */}
            {level?.levelDetails.detailssection2_heading && (
              <h3 className="description-clss mt-5 mb-3">
                {level?.levelDetails.detailssection2_heading}
              </h3>
            )}
            {level?.levelDetails.detailssection2_description && (
              <p className="about-description p-3">
                {level?.levelDetails.detailssection2_description}
              </p>
            )}

            {/* Learning Objectives */}
            {level?.levelDetails.detailssection3_heading && (
              <h3 className="lern-course mt-5 mb-3">
                {level?.levelDetails.detailssection3_heading}
              </h3>
            )}

            <ul className="list-unstyled about-description p-3 mb-3">
              {level?.levelDetails.detailssection3_pointer1 && (
                <li>
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  {level?.levelDetails.detailssection3_pointer1}
                </li>
              )}
              {level?.levelDetails.detailssection3_pointer2 && (
                <li>
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  {level?.levelDetails.detailssection3_pointer2}
                </li>
              )}
              {level?.levelDetails.detailssection3_pointer3 && (
                <li>
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  {level?.levelDetails.detailssection3_pointer3}
                </li>
              )}
              {level?.levelDetails.detailssection3_pointer4 && (
                <li>
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  {level?.levelDetails.detailssection3_pointer4}
                </li>
              )}
              {level?.levelDetails.detailssection3_pointer5 && (
                <li>
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  {level?.levelDetails.detailssection3_pointer5}
                </li>
              )}
              {level?.levelDetails.detailssection3_pointer6 && (
                <li>
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  {level?.levelDetails.detailssection3_pointer6}
                </li>
              )}
              {level?.levelDetails.detailssection3_pointer7 && (
                <li>
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  {level?.levelDetails.detailssection3_pointer7}
                </li>
              )}
              {level?.levelDetails.detailssection3_pointer8 && (
                <li>
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  {level?.levelDetails.detailssection3_pointer8}
                </li>
              )}
              {level?.levelDetails.detailssection3_pointer9 && (
                <li>
                  <i className="bi bi-check-circle-fill text-dark me-2"></i>
                  {level?.levelDetails.detailssection3_pointer9}
                </li>
              )}
              {/* <button className="custom-kickstart border-0 mt-3">
                Kickstart your inspection career today!
              </button> */}
            </ul>

            {/* Course Completion */}
            <div className="col-12 course-req-com mb-0">
              {level?.levelDetails.detailssection4_heading && (
                <h3>{level?.levelDetails.detailssection4_heading}</h3>
              )}
              <ul>
                {level?.levelDetails.detailssection4_pointer1 && (
                  <li>
                    <p>{level?.levelDetails.detailssection4_pointer1}</p>
                  </li>
                )}
                {level?.levelDetails.detailssetion4_pointer2 && (
                  <li>
                    <p>{level?.levelDetails.detailssetion4_pointer2}</p>
                  </li>
                )}
                {level?.levelDetails.detailssection4_pointer3 && (
                  <li>
                    <p>{level?.levelDetails.detailssection4_pointer3}</p>
                  </li>
                )}
                {level?.levelDetails.detailssection4_pointer4 && (
                  <li>
                    <p>{level?.levelDetails.detailssection4_pointer4}</p>
                  </li>
                )}

                {level?.levelDetails.detailssection4_heading && (
                  <p>{level?.levelDetails.detailssection4_description}</p>
                )}
              </ul>
              <RegisterButton className="custom-course-req-com-btn border-0 mb-5" />
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-4 d-flex flex-column gap-3">
            {/* Steps */}
            <div className="certified-card rounded-4 p-4 shadow border">
              <h4 className="fw-bold mb-4">
                {level?.levelDetails.detailsidesection2_title}
              </h4>
              <ul className="steps-list m-0 p-0 list-unstyled">
                <li className="d-flex position-relative mb-4">
                  <div className="icon-circle bg-dark text-white d-flex align-items-center justify-content-center">
                    <i className="bi bi-check"></i>
                  </div>
                  <div className="ms-3">
                    {level?.levelDetails.detailsidesection2_pointer1}
                  </div>
                  <div className="step-line"></div>
                </li>
                <li className="d-flex position-relative mb-4">
                  <div className="icon-circle bg-dark text-white d-flex align-items-center justify-content-center">
                    <i className="bi bi-check"></i>
                  </div>
                  <div className="ms-3">
                    {level?.levelDetails.detailsidesection2_pointer2}
                  </div>
                  <div className="step-line"></div>
                </li>
                <li className="d-flex position-relative mb-4">
                  <div className="icon-circle bg-dark text-white d-flex align-items-center justify-content-center">
                    <i className="bi bi-check"></i>
                  </div>
                  <div className="ms-3">
                    {level?.levelDetails.detailssidesection2_pointer3}
                  </div>
                  <div className="step-line"></div>
                </li>
              </ul>
            </div>

            {/* Bottom Card */}
            <div className="about-bttom-card text-dark p-4 rounded shadow border">
              {level?.levelDetails?.detailssidesection3_image && (
                <img
                  src={level.levelDetails.detailssidesection3_image}
                  alt="Career"
                  className="img-fluid rounded mb-3"
                />
              )}
              <h4 className="fw-bold">
                {level?.levelDetails.detailsidesection3_title}
              </h4>
              <p>{level?.levelDetails.detailssidesecion3_description}</p>
              <RegisterButton className="details-course-reg w-100 border-0" />
            </div>
          </div>
          <div className="main-schedule" ref={sectionRef}>
            <h3 className="course-prices">Course Price </h3>
            <p
              className="shadul-link text-dark p-4 rounded"
              style={{ background: "#ececec" }}
            >
              <p>Member Price: ${memberAmount} USD</p>
              <p>Non-Member Price: ${nonMemberAmount} USD</p>
            </p>
            {/* 
            <div
              className="shadul-link text-dark p-4 rounded"
              style={{ background: "#ececec" }}
            >
              <ul>
                <li>Day 1: 8:00 AM to 6:00 PM</li>
                <li>Day 2: 8:00 AM to 6:00 PM</li>
                <li>Day 3: 8:00 AM to 6:00 PM</li>
                <li>Day 4: 8:00 AM to 6:00 PM</li>
                <li>Day 5: 8:00 AM to 6:00 PM</li>
                <li>Day 6: 8:00 AM to 6:00 PM</li>
                <li>Day 7: 8:00 AM to 6:00 PM</li>
              </ul>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
